import script from "./PremiumPhonesModals.vue?vue&type=script&lang=ts&setup=true"
export * from "./PremiumPhonesModals.vue?vue&type=script&lang=ts&setup=true"

import "./PremiumPhonesModals.vue?vue&type=style&index=0&id=1c0bddc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c0bddc2"]])

export default __exports__